import React, { useEffect, useState } from "react";
import PolicyGrid from "../customer-policy-grid/CustomerPolicyGrid"; 
import { PolicyLocationReadDto } from "../../../model/PolicyLocationReadDto";
import { CustomerPolicyDetailLabels as cstPolicyCoverageLabel } from '../../../../shared/util/label';
import { fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { PolicySummaryErrorMessages } from "../../../../shared/util/constant";
import moment from "moment";

export interface ICustomerPolicyLocations {
  policyLocations: PolicyLocationReadDto[];
  onSelectLocation: (columnValue: any) => void;
}

const CustomerPolicyLocations: React.FunctionComponent<ICustomerPolicyLocations> = (props) => {

  const columns: any[] = [
    {
      Header: '',
      accessor: "id",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>
    },
    {
      Header: cstPolicyCoverageLabel.LOCATION_NUMBER,
      accessor: "locationNumber",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 150,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.ADDRESS,
      accessor: "address",
      Cell: row => {
        const { address1, address2 } = row.row.original; 
        const computedAddress = address1 && address2
          ? `${address1} ${address2}`
          : address1 || address2 || "";
        
        return <div><span title={computedAddress}>{computedAddress}</span></div>;
      },
      width: 450,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.CITY,
      accessor: "city",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 400,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.STATE,
      accessor: "state",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 350,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.ZIP_CODE,
      accessor: "zipCode",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 300,
      cellClassName:"",
      headerClassName: ""
    },
  ];

  const handleSelectedRow = (selected, columnValue) => {
    if(selected)
      props.onSelectLocation(columnValue);
    else
    props.onSelectLocation(null)

  };

  return (
    <PolicyGrid
      hiddenColumns={["id"]}
      data={props.policyLocations}
      columns={columns}
      gridId="policyLocationsGrid"
      sortDefault={[{ id: "locationNumber", asc: true }]}
      disableSorting ={true}
      highlightColumn='id'
      selectedColumn={handleSelectedRow}
      enableMandatorySelection= {true}
      noRecordsMessage={PolicySummaryErrorMessages.NO_LOCATION_FOUND}/>
  );
};

export default CustomerPolicyLocations;
